const fontLoader = function (fontFaceText) {
    return () => (new Promise((resolve) => {
        const fontStyle = document.createElement('style');
        fontStyle.type = 'text/css';
        fontStyle.appendChild(document.createTextNode(fontFaceText));
        document.head.appendChild(fontStyle);
        resolve(true);
    }));
};
export default fontLoader;
//# sourceMappingURL=font.web.js.map